// extracted by mini-css-extract-plugin
export var item = "izdeliya-module--item--hs+Ym";
export var mainwrapper = "izdeliya-module--mainwrapper--Mr-hp";